export enum Permission {
  OrdersV4View = 'orders_v4.view',
  OrdersV4Modify = 'orders_v4.modify',
}
